import { callExternalApi } from "./external-api.service";

const apiServerUrl = process.env.REACT_APP_TLOG_API_SERVER_URL;

export const getGeminiChatResponse = async (question) => {
  console.log("apiServerUrl:", apiServerUrl); // Debugging line
  const config = {
    url: `${apiServerUrl}/api/gemini-chat`,
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    data: { question }, // Axios uses 'data' for POST body
  };
  console.log("Axios config:", config); // Debugging line

  const { data, error } = await callExternalApi({ config });

  return {
    response: data,
    error,
  };
};